import classNames from 'classnames';
import React, { ReactNode } from 'react';

import { DEFAULT_UNKNOWN_TAG } from '@constants/filters';
import { ICellItem } from '@interfaces/ratingTable';
import { useFilters } from '@store/hooks/filters';

import { TCellFormat } from '../../../../../types/ratingTable';

import styles from './cell.module.scss';
import {
  NameCell,
  NumberCell,
  RatingCell,
  ResponseCountCell,
  ResponseSpeedCell,
  ReviewsCountCell,
  SolvedProblemsCell,
} from './formats';

interface ICellProps {
  children: ReactNode;
  cellFormat: TCellFormat;
  item?: ICellItem;
}

export const Cell = React.memo<ICellProps>(({ children, cellFormat, item }) => {
  const formatsMap = {
    number: NumberCell,
    rating: RatingCell,
    name: NameCell,
    reviewsCount: ReviewsCountCell,
    responseCount: ResponseCountCell,
    solvedProblems: SolvedProblemsCell,
    responseSpeed: ResponseSpeedCell,
  };

  const Component = formatsMap[cellFormat];
  const filters = useFilters();
  const tag = filters.reviewTag;

  return (
    <td className={classNames(styles.cell, styles[`cell--${cellFormat}`])}>
      <Component item={item} tag={tag.key !== DEFAULT_UNKNOWN_TAG.key && tag.key}>
        {children}
      </Component>
    </td>
  );
});
